import { useState } from 'react';

const tabs = [
  { id: 'case01', label: '事例 01｜卸業・47名', available: true },
  { id: 'case02', label: '事例 02｜準備中', available: false },
  { id: 'case03', label: '事例 03｜準備中', available: false },
];

const caseData = {
  profile: [
    { label: '業種', value: '卸業' },
    { label: '従業員数', value: '47名' },
    { label: '創業', value: '18年' },
    { label: '意思決定者', value: '代表取締役' },
  ],
  rows: [
    {
      before: '納得感不足による離職増加',
      after: '評価への納得感が向上し離職が減少',
    },
    {
      before: '職種ごとの評価基準が不明確',
      after: '役割と評価基準を明確化し透明性向上',
    },
    {
      before: '給与水準が市場と比べ競争力不足',
      after: '市場水準に沿った報酬テーブルを整備',
    },
    {
      before: '管理職登用ルール・育成体制が未整備',
      after: '人件費の最適配分を実現',
    },
    {
      before: '後継者育成の仕組みが不在',
      after: '社員のキャリアの道筋が明確化',
    },
    {
      before: '組織の持続的成長に対する不安',
      after: '専門性向上につながる育成基盤を整備',
    },
  ],
};

export default function CaseStudy() {
  const [activeTab, setActiveTab] = useState('case01');

  return (
    <section
      id="cases"
      className="py-20"
      style={{ background: '#F7F9FC', fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto px-6">
        {/* セクションヘッダー */}
        <div className="text-center mb-12">
          <span
            className="inline-block text-xs font-medium px-3 py-1 rounded-full mb-4"
            style={{ background: '#EEF4FB', color: '#1A5CB0', letterSpacing: '0.08em' }}
          >
            CASE STUDY
          </span>
          <h2
            className="text-3xl font-bold mb-3"
            style={{ color: '#0D2B55', letterSpacing: '-0.01em' }}
          >
            導入事例
          </h2>
          <p className="text-sm" style={{ color: '#667085' }}>
            人事制度の整備・改善を通じて成果を上げた企業の事例をご紹介します
          </p>
        </div>

        {/* タブ */}
        <div className="flex gap-2 mb-8 flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => tab.available && setActiveTab(tab.id)}
              className="text-sm font-medium px-5 py-2.5 rounded-lg transition-all whitespace-nowrap"
              style={
                tab.available
                  ? activeTab === tab.id
                    ? {
                        background: '#0D2B55',
                        color: '#fff',
                        cursor: 'pointer',
                      }
                    : {
                        background: '#fff',
                        color: '#1A1A2E',
                        border: '1px solid #D0DCF0',
                        cursor: 'pointer',
                      }
                  : {
                      background: '#F0F0F5',
                      color: '#AAAABC',
                      cursor: 'not-allowed',
                      border: '1px solid #E0E4EF',
                    }
              }
            >
              {tab.label}
              {!tab.available && (
                <span
                  className="ml-2 text-xs px-1.5 py-0.5 rounded"
                  style={{ background: '#E8EBF4', color: '#9A9AB0', fontSize: '10px' }}
                >
                  近日公開
                </span>
              )}
            </button>
          ))}
        </div>

        {/* ケース本体 */}
        {activeTab === 'case01' && (
          <div
            className="rounded-xl overflow-hidden"
            style={{ border: '1px solid #D0DCF0', background: '#fff' }}
          >
            {/* ヘッダーバー */}
            <div
              className="px-8 py-5 flex flex-wrap items-center gap-3"
              style={{ background: '#EEF4FB', borderBottom: '1px solid #D0DCF0' }}
            >
              <span
                className="text-xs font-bold px-2.5 py-1 rounded"
                style={{ background: '#0D2B55', color: '#fff' }}
              >
                事例 01
              </span>
              <span className="text-sm font-bold" style={{ color: '#0D2B55' }}>
                卸業 ・ 従業員 47名
              </span>
              <div className="flex flex-wrap gap-2 ml-2">
                {caseData.profile.map((item) => (
                  <span
                    key={item.label}
                    className="text-xs px-3 py-1 rounded-full"
                    style={{
                      background: '#fff',
                      border: '1px solid #D0DCF0',
                      color: '#455A64',
                    }}
                  >
                    <span style={{ color: '#667085' }}>{item.label}：</span>
                    <span className="font-medium" style={{ color: '#1A1A2E' }}>{item.value}</span>
                  </span>
                ))}
              </div>
            </div>

            {/* Before / After テーブル */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr>
                    <th
                      className="w-1/2 px-8 py-4 text-left text-sm font-bold"
                      style={{ color: '#fff', background: '#455A64' }}
                    >
                      <div className="flex items-center gap-2">
                        <span
                          className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                          style={{ background: 'rgba(255,255,255,0.2)' }}
                        >
                          –
                        </span>
                        導入前の課題
                      </div>
                    </th>
                    <th
                      className="w-1/2 px-8 py-4 text-left text-sm font-bold"
                      style={{ color: '#fff', background: '#0D2B55' }}
                    >
                      <div className="flex items-center gap-2">
                        <span
                          className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                          style={{ background: 'rgba(45,142,255,0.4)' }}
                        >
                          →
                        </span>
                        導入後の変化
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {caseData.rows.map((row, i) => (
                    <tr key={i}>
                      <td
                        className="px-8 py-4 text-base align-top"
                        style={{
                          background: i % 2 === 0 ? '#F7F9FC' : '#fff',
                          borderBottom: '1px solid #E8EDF5',
                          color: '#455A64',
                        }}
                      >
                        <div className="flex items-start gap-3">
                          <span
                            className="mt-0.5 w-5 h-5 flex-shrink-0 rounded-full flex items-center justify-center text-xs font-bold"
                            style={{ background: '#E8EDF5', color: '#667085' }}
                          >
                            –
                          </span>
                          <span style={{ lineHeight: '1.6' }}>{row.before}</span>
                        </div>
                      </td>
                      <td
                        className="px-8 py-4 text-base align-top"
                        style={{
                          background: i % 2 === 0 ? '#F0F6FF' : '#EEF4FB',
                          borderBottom: '1px solid #E8EDF5',
                          color: '#1A1A2E',
                        }}
                      >
                        <div className="flex items-start gap-3">
                          <span
                            className="mt-0.5 w-5 h-5 flex-shrink-0 rounded-full flex items-center justify-center text-xs font-bold"
                            style={{ background: '#2D8EFF', color: '#fff' }}
                          >
                            →
                          </span>
                          <span className="font-medium" style={{ lineHeight: '1.6' }}>{row.after}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* フッター */}
            <div
              className="px-8 py-5 flex items-center justify-between flex-wrap gap-3"
              style={{ background: '#EEF4FB', borderTop: '1px solid #D0DCF0' }}
            >
              <p className="text-sm" style={{ color: '#667085' }}>
                ※ 掲載にあたり、企業情報の一部を変更しています
              </p>
              <a
                href="https://products-eight-sand.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-bold px-6 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                style={{ background: '#0D2B55', color: '#fff' }}
              >
                貴社も診断を受ける →
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
